import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";

const TABS = [["possible", "Possible matches"], ["duplicate", "Duplicates"], ["exact_phone", "Phone matches"], ["exact_email", "Email matches"], ["unmatched", "Unmatched"]];

function Row({ r, batchId, onDecided }) {
  const decide = async (decision, customer_id) => {
    try { const x = await api.post(`/wa/import/${batchId}/review`, { msisdn: r.msisdn, decision, customer_id }); onDecided(r.msisdn, x.data.decision); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not save"); }
  };
  const d = r.decision;
  return (
    <div className="py-2" data-testid={`wa-review-row-${r.msisdn}`}>
      <div className="text-sm text-slate-800"><b>{r.name || "No name"}</b> · {r.msisdn}{r.email ? ` · ${r.email}` : ""}{r.superchat_contact_ids.length ? ` · Superchat ${r.superchat_contact_ids.join(", ")}` : ""}</div>
      <div className="flex flex-wrap gap-1.5 mt-1">
        {r.match.candidates.map((c) => (
          <Button key={c.customer_id} size="sm" variant={d?.customer_id === c.customer_id ? "default" : "outline"} onClick={() => decide("link", c.customer_id)} data-testid={`wa-review-link-${r.msisdn}-${c.customer_id}`}>
            Link: {c.full_name || "?"} #{c.customer_id}{c.email ? ` · ${c.email}` : ""}{c.history ? ` · ${c.history.jobs} jobs, ${c.history.purchases} purchases` : ""}
          </Button>
        ))}
        <Button size="sm" variant={d?.decision === "standalone" ? "default" : "ghost"} onClick={() => decide("standalone")} data-testid={`wa-review-standalone-${r.msisdn}`}>Keep standalone</Button>
      </div>
      {d && <div className="text-[11px] text-emerald-600 mt-0.5">Decided: {d.decision}{d.customer_id ? ` → #${d.customer_id}` : ""} by {d.by}{d.bulk ? " (bulk)" : ""}</div>}
    </div>
  );
}

export function WaImportReview({ batchId, onChange }) {
  const [tab, setTab] = useState("possible");
  const [data, setData] = useState(null);
  const load = () => api.get(`/wa/import/${batchId}/review`, { params: { status: tab, limit: 100 } }).then((r) => setData(r.data));
  useEffect(() => { load(); }, [tab, batchId]); // eslint-disable-line react-hooks/exhaustive-deps
  const decided = (msisdn, dec) => { setData({ ...data, items: data.items.map((x) => (x.msisdn === msisdn ? { ...x, decision: dec } : x)) }); api.get(`/wa/import/${batchId}/review`, { params: { status: tab, limit: 1 } }).then((r) => onChange(r.data.report)); };
  const bulk = async () => {
    try {
      const p = (await api.post(`/wa/import/${batchId}/review/bulk-strong`, { apply: false })).data;
      if (!p.count) { toast.info("No undecided strong matches"); return; }
      const ex = p.sample.slice(0, 5).map((s) => `${s.name} → ${s.customer.full_name} #${s.customer.customer_id}`).join("\n");
      if (!window.confirm(`Link ${p.count} possible matches where the full name is identical and there is only one candidate?\n\nExamples:\n${ex}\n\nEach one can still be changed individually.`)) return;
      const r = (await api.post(`/wa/import/${batchId}/review/bulk-strong`, { apply: true })).data;
      toast.success(`Linked ${r.count} strong matches`); onChange(r.report); load();
    } catch (e) { toast.error(e.response?.data?.detail || "Bulk review failed"); }
  };
  return (
    <div className="mt-4 rounded-xl border border-slate-200 p-3" data-testid="wa-import-review">
      <div className="flex flex-wrap gap-1 mb-2">
        {TABS.map(([k, label]) => <button key={k} onClick={() => setTab(k)} data-testid={`wa-review-tab-${k}`} className={`text-xs rounded-full px-2.5 py-1 border ${tab === k ? "bg-indigo-600 text-white border-indigo-600" : "border-slate-200 text-slate-600"}`}>{label}</button>)}
        {tab === "possible" && <Button size="sm" variant="outline" className="ml-auto" onClick={bulk} data-testid="wa-review-bulk-strong">Bulk-link strong matches</Button>}
      </div>
      {!data ? null : data.total === 0 ? <div className="text-xs text-slate-400">None</div> : (
        <div className="divide-y divide-slate-100 max-h-96 overflow-auto">
          {data.items.map((r) => <Row key={r.msisdn} r={r} batchId={batchId} onDecided={decided} />)}
          {data.total > data.items.length && <div className="text-xs text-slate-400 py-2">Showing {data.items.length} of {data.total}</div>}
        </div>
      )}
    </div>
  );
}
